export const REVERT_LOG_START = 'REVERT_LOG_START'
export const REVERT_LOG_SUCCESS = 'REVERT_LOG_SUCCESS'
export const REVERT_LOG_FAIL = 'REVERT_LOG_FAIL'
